/* eslint-disable */

import { getCookie, getQuery } from 'sutils';
import { getCommonExtData } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/common-ext-data';

function printVersion(): void {
    const commExtData = getCommonExtData();
    window.log?.info('环境信息:', commExtData);

    const getColorStyle = (color: string, fontSize = 12) => `display:inline-block;background:${color};color:#fff;padding:2px 4px;font-size:${fontSize}px;`;
    console.log(`%c数据版本%c${commExtData.isVer3 ? '3.0.0' : '2.0.0'}`, getColorStyle('#e07800'), getColorStyle('rgba(69, 77, 90, 0.6)'));
    console.log(`%c当前环境%c${commExtData.env}`, getColorStyle('#e07800'), getColorStyle('rgba(69, 77, 90, 0.6)'));
    if (['test', 'production'].includes(commExtData.env)) {
        console.log(`%c发布版本%c${commExtData.codeVersion}`, getColorStyle('#e07800'), getColorStyle('rgba(69, 77, 90, 0.6)'));
        console.log(`%c构建版本%c${window.__globalReleaseVersion}`, getColorStyle('#e07800'), getColorStyle('rgba(69, 77, 90, 0.6)'));
    }
    if (['development', 'test'].includes(commExtData.env)) {
        const tipData = {
            window挂载service: { 开发: '✅', 测试: '✅', 线上: '❌' },
            控制台显示原生log: { 开发: '✅', 测试: '✅', 线上: 'sh0wl0g=1' },
            控制台禁掉weblog: { 开发: 'hideWeblog=1 + 页面重刷2次', 测试: 'hideWeblog=1 + 页面重刷2次', 线上: '❌' },
            控制台打印tdw埋点: { 开发: 'showTdw=1', 测试: 'showTdw=1', 线上: '❌' },
        };
        console.table(tipData);
        // const getColorStyle1 = (color: string, fontSize = 12) => `display:inline-block;background:${color};padding:2px 4px;font-size:${fontSize}px;`;
        // console.log('%cpresentation%c window.appServices.uiDataService.presentation', getColorStyle1('rgb(223,232,249)'), getColorStyle1('rgb(249,250,251)'));
        // console.log('%c当前选中元素%c window.appServices.viewableServiceLayer.selectionService.selectedElements.selectedArray[0]', getColorStyle1('rgb(223,232,249)'), getColorStyle1('rgb(249,250,251)'));
        // 注释下面代码可去除折叠功能
        // window.console.groupCollapsed('点击展开日志（清除日志可去除折叠功能）');
    }
}

printVersion();

// 测试环境（rootProxy）都能看到log，外网手动拼showLog=1能看到log
if (!getCookie('free_go_proxy') && !getCookie('env_id') && getQuery('sh0wl0g') !== '1') {
    console.log = function () {};
    console.info = function () {};
    console.warn = function () {};
    console.error = function () {};
    console.debug = function () {};
    console.table = function () {};
}
